// import { createBrowserRouter } from "react-router-dom";
// import ErrorPart from "../components/errorImg/ErrorPart";
// import Login from "../components/Login/Login";
// import Main from "../Layout/Main";
// import VolunteerBankPage from "../pages/VolunteerPage/VolunteerBankPage";
// import VolunteerRegisterPage from "../pages/VolunteerPage/VolunteerRegisterPage";
// import UserSetup from "../pages/UserSetup";
// import DashboardPage from "../pages/DashboardPage";
// import PrivateRoute from "./PrivateRoute/PrivateRoute";
// import VolunteerPROPage from "../pages/VolunteerPage/VolunteerPROPage";
// import UserLevelPage from "../pages/SecurityPage/UserLevelPage";
// import OccupationSetupPage from "../pages/SetupPage/OccupationSetupPage/OccupationSetupPage";
// import StudySetupPage from "../pages/SetupPage/StudySetupPage";
// import SponsorSetupPage from "../pages/SetupPage/SponsorSetupPage";
// import ApproveVolunteerPage from "../pages/DashboardTotalPage/ApproveVolunteerPage";
// import TotalVolunteerPage from "../pages/DashboardTotalPage/TotalVolunteerPage";
// import PendingVolunteerPage from "../pages/DashboardTotalPage/PendingVolunteerPage";
// import TodayAddVolunteerPage from "../pages/DashboardTotalPage/TodayAddVolunteerPage";
// import UserReportPage from "../pages/DashboardTotalPage/UserReportPage";
// import AdminRoute from "./PrivateRoute/AdminRoute";
// import ProfilePage from "../pages/ProfilePage";
// import PdfVolProfile from "../components/Volunteer/PdfVolProfile";
// import EmployeeSetupPage from "../pages/SetupPage/EmployeeSetupPage";
// import ThanaSetupPage from "../pages/SetupPage/ThanaSetupPage";
// import LevelManagementPage from "../pages/SecurityPage/LevelManagementPage";
// import RemarkSetupPage from "../pages/SetupPage/RemarkSetupPage";

// const router = createBrowserRouter([
//   {
//     // path: "/",
//     element: (
//       <PrivateRoute>
//         <Main></Main>
//       </PrivateRoute>
//     ),
//     children: [
//       {
//         path: "/",
//         element: <DashboardPage />,
//       },
//       {
//         path: "security/user-level",
//         element: (
//           <AdminRoute>
//             <UserLevelPage />
//           </AdminRoute>
//         ),
//       },
//       {
//         path: "security/level-management",
//         element: (
//           <AdminRoute>
//             <LevelManagementPage/>
//           </AdminRoute>
//         ),
//       },
//       {
//         path: "setup/user-setup",
//         element: (
//           <AdminRoute>
//             <UserSetup />
//           </AdminRoute>
//         ),
//       },
//       {
//         path: "setup/occupation-setup",
//         element: <OccupationSetupPage />,
//       },
//       {
//         path: "setup/study-setup",
//         element: (
//           <AdminRoute>
//             <StudySetupPage />
//           </AdminRoute>
//         ),
//       },
//       {
//         path: "setup/sponsor-setup",
//         element: (
//           <AdminRoute>
//             <SponsorSetupPage />
//           </AdminRoute>
//         ),
//       },
//       {
//         path: "setup/remark-setup",
//         element: (
//           <AdminRoute>
//             <RemarkSetupPage />
//           </AdminRoute>
//         ),
//       },
//       // {
//       //   path: "setup/employee-setup",
//       //   element: (
//       //     <AdminRoute>
//       //       <EmployeeSetupPage />
//       //       </AdminRoute>
//       //   ),
//       // },
//       {
//         path: "setup/thana-setup",
//         element: (

//            <ThanaSetupPage/>

//         ),
//       },

//       {
//         path: "/volunteer/volunteerRegister",
//         element: <VolunteerRegisterPage />,
//       },
//       {
//         path: "/volunteer/VolunteerPro",
//         element: <VolunteerPROPage />,
//       },
//       {
//         path: "/volunteer/volunteerBank",
//         element: <VolunteerBankPage />,
//       },
//       {
//         path: "/profile",
//         element: <ProfilePage />,
//       },
//     ],
//   },
//   {
//     // element: <PrivateRoute>{children}</PrivateRoute>,
//     children: [
//       {
//         path: "/approve-volunteer",
//         element: (
//           <PrivateRoute>
//             <ApproveVolunteerPage />
//           </PrivateRoute>
//         ),
//       },
//       {
//         path: "/total-volunteer",
//         element: (
//           <PrivateRoute>
//             <TotalVolunteerPage />
//           </PrivateRoute>
//         ),
//       },
//       {
//         path: "/pending-volunteer",
//         element: (
//           <PrivateRoute>
//             <PendingVolunteerPage />
//           </PrivateRoute>
//         ),
//       },
//       {
//         path: "/today-volunteer",
//         element: (
//           <PrivateRoute>
//             <TodayAddVolunteerPage />
//           </PrivateRoute>
//         ),
//       },
//       {
//         path: "/user-report",
//         element: (
//           <PrivateRoute>
//             <UserReportPage />
//           </PrivateRoute>
//         ),
//       },
//     ],
//   },
//   {
//     path: "/login",
//     element: <Login />,
//   },

//   {
//     path: "*",
//     element: <ErrorPart />,
//   },
// ]);

// export default router;
import React from "react";
import { createBrowserRouter } from "react-router-dom";
import ErrorPart from "../components/errorImg/ErrorPart";
import Login from "../components/Login/Login";
import Main from "../Layout/Main";
import DashboardPage from "../pages/DashboardPage";
import ApproveVolunteerPage from "../pages/DashboardTotalPage/ApproveVolunteerPage";
import CurrentStudiesPage from "../pages/DashboardTotalPage/CurrentStudiesPage";
import CurrentStudyVolunteers from "../pages/DashboardTotalPage/CurrentStudyVolunteers";
import InactiveVolunteers from "../pages/DashboardTotalPage/InactiveVolunteers";
import PendingVolunteerPage from "../pages/DashboardTotalPage/PendingVolunteerPage";
import StoragePage from "../pages/DashboardTotalPage/StoragePage";
import TodayAddVolunteerPage from "../pages/DashboardTotalPage/TodayAddVolunteerPage";
import TotalVolunteerPage from "../pages/DashboardTotalPage/TotalVolunteerPage";
import UserReportPage from "../pages/DashboardTotalPage/UserReportPage";
import ProfilePage from "../pages/ProfilePage";
import LevelManagementPage from "../pages/SecurityPage/LevelManagementPage";
import MenuSetupPage from "../pages/SecurityPage/MenuSetupPage";
import SubMenuSetupPage from "../pages/SecurityPage/SubMenuSetupPage";
import UserLevelPage from "../pages/SecurityPage/UserLevelPage";
import OccupationSetupPage from "../pages/SetupPage/OccupationSetupPage/OccupationSetupPage";
import RemarkSetupPage from "../pages/SetupPage/RemarkSetupPage";
import SponsorSetupPage from "../pages/SetupPage/SponsorSetupPage";
import StudySetupPage from "../pages/SetupPage/StudySetupPage";
import ThanaSetupPage from "../pages/SetupPage/ThanaSetupPage";
import TrialSetupPage from "../pages/SetupPage/TrialSetupPage";

import UserSetup from "../pages/UserSetup";
import VolunteerBankPage from "../pages/VolunteerPage/VolunteerBankPage";
import VolunteerPROPage from "../pages/VolunteerPage/VolunteerPROPage";
import VolunteerRegisterPage from "../pages/VolunteerPage/VolunteerRegisterPage";
import AdminRoute from "./PrivateRoute/AdminRoute";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import TrialPage from "../pages/TrialPage/TrialPage";
import CurrentTrialVolunteers from "../pages/TrialPage/CurrentTrialVolunteers";
import VolunteersFromWebPage from "../pages/VolunteersFromWeb/VolunteersFromWebPage";
const routData = "Y";

const item = JSON.parse(localStorage.getItem("items"));

// console.log(item);
const router = createBrowserRouter([
  {
    // path: "/",
    element: (
      <PrivateRoute>
        <Main />
      </PrivateRoute>
    ),
    children: [
      {
        // path: "/",
        path: item?.a15b?.abc === "Y" ? "/" : "",
        element: <DashboardPage />,
      },

      //! security user level
      {
        // path: "security/user-level",
        path: item?.a3b?.abc === "Y" ? "security/user-level" : "",
        element: (
          <AdminRoute>
            {routData === "Y" ? <UserLevelPage /> : <DashboardPage />}
          </AdminRoute>
        ),
      },

      //! security  level management
      {
        path: "security/level-management",
        element: (
          <AdminRoute>
            <LevelManagementPage />
          </AdminRoute>
        ),
      },

      //! security menu setup
      {
        // path: "security/menu-setup",
        path: item?.a5b?.abc === "Y" ? "security/menu-setup" : "",
        element: <MenuSetupPage />,
      },

      //! security sub-menu setup
      {
        // path: "security/submenu-setup",
        path: item?.a2b?.abc === "Y" ? "security/submenu-setup" : "",
        element: <SubMenuSetupPage />,
      },

      //! user setup
      {
        path:
          JSON.parse(localStorage.getItem("items"))?.a6b?.abc === "Y"
            ? "setup/user-setup"
            : "",
        // path: routData === "Y" ? "setup/user-setup" : "",
        // path: "setup/user-setup",
        element: (
          <AdminRoute>
            <UserSetup />
          </AdminRoute>
        ),
      },

      //! occupation setup
      {
        // path: "setup/occupation-setup",
        path: item?.a7b?.abc === "Y" ? "setup/occupation-setup" : "",
        element: <OccupationSetupPage />,
      },

      //! study setup
      {
        // path: "setup/study-setup",
        path: item?.a9b?.abc === "Y" ? "setup/study-setup" : "",
        element: (
          <AdminRoute>
            <StudySetupPage />
          </AdminRoute>
        ),
      },

      //! sponsor setup
      {
        // path: "setup/sponsor-setup",
        path: item?.a8b?.abc === "Y" ? "setup/sponsor-setup" : "",
        element: (
          <AdminRoute>
            <SponsorSetupPage />
          </AdminRoute>
        ),
      },
      // {
      //   path: "setup/sponsor-setup",
      //   element: (
      //     <AdminRoute>
      //       <SponsorSetupPage />
      //     </AdminRoute>
      //   ),
      // },

      //! remark setup
      {
        path: "setup/remark-setup",
        element: (
          <AdminRoute>
            <RemarkSetupPage />
          </AdminRoute>
        ),
      },

      //! trial setup
      {
        path: "setup/trial-setup",
        element: (
          <AdminRoute>
            <TrialSetupPage />
          </AdminRoute>
        ),
      },
      // {
      //   path: "setup/employee-setup",
      //   element: (
      //     <AdminRoute>
      //       <EmployeeSetupPage />
      //       </AdminRoute>
      //   ),
      // },

      //! thana setup
      {
        // path: "study",
        path: item?.a18b?.abc === "Y" ? "/setup/thana-setup" : "",
        element: <ThanaSetupPage />,
      },

      // {
      //   path: "setup/thana-setup",
      //   element: (

      //      <ThanaSetupPage/>

      //   ),
      // },

      //! volunteer register
      {
        // path: "/volunteer/volunteerRegister",
        path: item?.a10b?.abc === "Y" ? "/volunteer/volunteerRegister" : "",
        element: <VolunteerRegisterPage />,
      },

      //! volunteer PRO
      {
        // path: "/volunteer/VolunteerPro",
        path: item?.a11b?.abc === "Y" ? "/volunteer/VolunteerPro" : "",
        element: <VolunteerPROPage />,
      },

      //! volunteer bank
      {
        // path: "/volunteer/volunteerBank",
        path: item?.a12b?.abc === "Y" ? "/volunteer/volunteerBank" : "",
        element: <VolunteerBankPage />,
      },

      {
        path: "/trial",
        element: (
          <PrivateRoute>
            <TrialPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/volunteerFromWeb",
        element: (
          <PrivateRoute>
            <VolunteersFromWebPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/trial/:trialCode",
        element: (
          <PrivateRoute>
            <CurrentTrialVolunteers />
          </PrivateRoute>
        ),
      },

      //! Profile
      {
        path: "/profile",
        element: <ProfilePage />,
      },
      // {
      //   // path: "study",
      //   path: item?.a13b?.abc === "Y" ? "/study" : "",
      //   element: <FirstContactPage />,
      // },
    ],
  },
  {
    // element: <PrivateRoute>{children}</PrivateRoute>,
    children: [
      //! approve volunteer
      {
        path: "/approve-volunteer",
        element: (
          <PrivateRoute>
            <ApproveVolunteerPage />
          </PrivateRoute>
        ),
      },

      //! total volunteer
      {
        path: "/total-volunteer",
        element: (
          <PrivateRoute>
            <TotalVolunteerPage />
          </PrivateRoute>
        ),
      },

      //! pending volunteer
      {
        path: "/pending-volunteer",
        element: (
          <PrivateRoute>
            <PendingVolunteerPage />
          </PrivateRoute>
        ),
      },

      //! volunteer storage
      {
        path: "/volunteer-storage",
        element: (
          <PrivateRoute>
            <StoragePage />
          </PrivateRoute>
        ),
      },

      //! current trials
      {
        path: "/current-studies",
        element: (
          <PrivateRoute>
            <CurrentStudiesPage />
          </PrivateRoute>
        ),
      },

      //! current trials volunteers list
      {
        path: "/current-studies/:studyCode",
        element: (
          <PrivateRoute>
            <CurrentStudyVolunteers />
          </PrivateRoute>
        ),
      },

      //! inactive volunteer
      {
        path: "/inactive-volunteer",
        element: (
          <PrivateRoute>
            <InactiveVolunteers />
          </PrivateRoute>
        ),
      },

      //! today volunteer
      {
        path: "/today-volunteer",
        element: (
          <PrivateRoute>
            <TodayAddVolunteerPage />
          </PrivateRoute>
        ),
      },

      //! user report
      {
        path: "/user-report",
        element: (
          <PrivateRoute>
            <UserReportPage />
          </PrivateRoute>
        ),
      },
    ],
  },

  //! login
  {
    path: "/login",
    element: <Login />,
  },

  {
    path: "*",
    element: <ErrorPart />,
  },
]);

export default router;
